"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cache = void 0;
class Cache {
    value;
    valueTimestamp;
    valueFactory;
    maxAgeInMilliseconds;
    constructor(valueFactory, maxAgeInMilliseconds) {
        this.valueFactory = valueFactory;
        this.maxAgeInMilliseconds = maxAgeInMilliseconds;
    }
    async get() {
        const now = Date.now();
        if ((this.valueTimestamp === undefined) || (now > (this.valueTimestamp + this.maxAgeInMilliseconds))) {
            this.value = await this.valueFactory();
            this.valueTimestamp = now;
        }
        return this.value;
    }
}
exports.Cache = Cache;
//# sourceMappingURL=Cache.js.map